import React, { useMemo } from 'react';
import classNames from 'classnames';
import styles from './Navigation.scss.js';
import useArrowKeysNavigation from '../Hooks/useArrowKeysNavigation/useArrowKeysNavigation.js';
import NavigationItem from './NavigationItem/NavigationItem.js';
import { Theme } from '../../../helpers/enums/themes/themeTypes.js';

const Navigation = _ref => {
  let {
    theme = Theme.WHITE,
    itemsData,
    isCompact,
    onSelect = () => {},
    children,
    selectedItem = '',
    fontSize,
    onActionButtonClick = () => {}
  } = _ref;
  const itemsCount = useMemo(() => itemsData.reduce((total, category) => total + category.items.length, 0), [itemsData]);
  const {
    containerRef,
    onBlur,
    onFocus,
    handleKeyDown,
    setSelectedItemIndex,
    setItemRefToIndex
  } = useArrowKeysNavigation(itemsCount);
  const handleClick = (item, index) => {
    setSelectedItemIndex(index);
    onSelect(item);
  };
  const handleActionButtonClick = item => onActionButtonClick(item);
  const getItemIndex = (categoryIndex, itemIndex) => {
    if (categoryIndex < 0) {
      return itemIndex;
    }
    const prev = getItemIndex(categoryIndex - 1, 0);
    return (itemsData[categoryIndex]?.items?.length || 0) + prev + itemIndex;
  };
  return /*#__PURE__*/React.createElement("nav", {
    ref: containerRef,
    onBlur: onBlur,
    onFocus: onFocus,
    className: classNames(styles.container, {
      [styles[`container--${theme}`]]: true,
      [styles['container--compact']]: isCompact
    })
  }, children && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, children), /*#__PURE__*/React.createElement("hr", {
    className: styles.separator
  })), itemsData.map((category, index) => {
    const isLastCategory = index === itemsData.length - 1;
    return /*#__PURE__*/React.createElement("section", {
      key: category.name,
      className: styles.category,
      "aria-label": category.name
    }, category.label && /*#__PURE__*/React.createElement("h4", {
      className: styles['category-header']
    }, category.label), /*#__PURE__*/React.createElement("ul", {
      className: styles['category-items']
    }, category.items.map((item, idx) => {
      const itemIndex = getItemIndex(index - 1, idx);
      return /*#__PURE__*/React.createElement("li", {
        key: item.name,
        "aria-setsize": category.items.length,
        "aria-posinset": idx + 1
      }, /*#__PURE__*/React.createElement(NavigationItem, {
        isCompact: isCompact,
        theme: theme,
        icon: item.icon,
        active: selectedItem === item.name,
        label: item.label,
        indentedLabel: item.indentedLabel,
        pill: item.pill,
        counter: item.counter,
        aditionalTextForScreenReader: item.aditionalTextForScreenReader,
        onClick: () => handleClick(item, itemIndex),
        innerRef: el => {
          setItemRefToIndex(el, itemIndex);
        },
        onKeyPress: handleKeyDown,
        fontSize: fontSize,
        actionButton: item.actionButton,
        onActionButtonClick: () => handleActionButtonClick(item)
      }));
    })), !isLastCategory && /*#__PURE__*/React.createElement("hr", {
      className: styles.separator
    }));
  }));
};
var Navigation$1 = Navigation;

export { Navigation$1 as default };
//# sourceMappingURL=Navigation.js.map
